import { Locale } from '@synergy/models';

export const localesReducer = (state: Locale[] = []) => {
    return state;
};
